import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    authenticated: Boolean,
    websiteId: String,
    email: String,
    civility: String,
    phoneNumber: String,
    tokenId: String,
    nickname: String,
    signature: String,
    consentRequired: Boolean
  };

  connect() {
    if (!this.emailValue) return;

    if (this.#consentAlreadyGiven()) {
      this.loadAndApply();
    }
  }

  loadAndApply() {
    if (!this.emailValue) return;
    if (!this.#consentAlreadyGiven()) return;

    this.#loadScript();
    this.#apply();
  }

  #consentAlreadyGiven() {
    if (!this.consentRequiredValue) return true;

    // We analyze Cookie Script cookie to verifiy that user has consented to Crisp.
    const cookie = document.cookie
      .split('; ')
      .find(row => row.startsWith('CookieScriptConsent='));

    if (!cookie) return false;

    try {
      const value = JSON.parse(decodeURIComponent(cookie.split('=')[1]));
      return value.action === 'accept';
    } catch {
      return false;
    }
  }

  #loadScript() {
    window.$crisp = window.$crisp || [];

    if (window.__crispLoaded) return;

    window.__crispLoaded = true;
    window.CRISP_WEBSITE_ID = this.websiteIdValue;

    if (this.tokenIdValue) {
      window.CRISP_TOKEN_ID = this.tokenIdValue;
    }

    const s = document.createElement('script');
    s.src = 'https://client.crisp.chat/l.js';
    s.async = true;
    document.head.appendChild(s);
  }

  #apply() {
    this.#push(['do', 'session:reset']);

    if (this.tokenIdValue) {
      this.#setTokenId(this.tokenIdValue);
    }

    this.#setEmail(this.emailValue);

    if (this.civilityValue) {
      this.#setCivility(this.civilityValue);
    }

    if (this.phoneNumberValue) {
      this.#setPhoneNumber(this.phoneNumberValue);
    }

    if (this.nicknameValue) {
      this.#setNickname(this.nicknameValue);
    }

    this.#chatShow();
  }

  #push(command) {
    window.$crisp.push(command);
  }

  #setTokenId(tokenId) {
    this.#push(['set', 'session:token_id', tokenId]);
  }

  #setEmail(email) {
    if (this.signatureValue) {
      this.#push(['set', 'user:email', [email, this.signatureValue]]);
    } else {
      this.#push(['set', 'user:email', [email]]);
    }
  }

  #setCivility(civility) {
    this.#push(['set', 'session:data', [[['civility', civility]]]]);
  }

  #setPhoneNumber(phone) {
    this.#push(['set', 'user:phone', [phone]]);
  }

  #setNickname(nickname) {
    this.#push(['set', 'user:nickname', [nickname]]);
  }

  #chatShow() {
    this.#push(['do', 'chat:show']);
  }
}
